/**
 * @generated SignedSource<<c55ac809e378be9985acddf9c9432a3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utils_useMeetingRecorderStatus_note$data = {
  readonly groupName: string;
  readonly " $fragmentType": "utils_useMeetingRecorderStatus_note";
};
export type utils_useMeetingRecorderStatus_note$key = {
  readonly " $data"?: utils_useMeetingRecorderStatus_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"utils_useMeetingRecorderStatus_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "utils_useMeetingRecorderStatus_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupName",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "02219e6ff3247d1c68f3dd7d877daefc";

export default node;
